import { render } from "./VendorPriceValidatorIndex.vue?vue&type=template&id=8fbd2128"
import script from "./VendorPriceValidatorIndex.vue?vue&type=script&lang=js"
export * from "./VendorPriceValidatorIndex.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__